import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import api from '../services/api';

const AuthContexte = createContext(null);

export function AuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem('shopmarega_token') || '');
  const [utilisateur, setUtilisateur] = useState(() => {
    const raw = localStorage.getItem('shopmarega_utilisateur');
    return raw ? JSON.parse(raw) : null;
  });

  useEffect(() => {
    let mounted = true;

    async function chargerMe() {
      if (!token) return;
      try {
        const { data } = await api.get('/me');
        if (!mounted) return;
        setUtilisateur(data);
      } catch (e) {
        if (!mounted) return;
        setToken('');
        setUtilisateur(null);
      }
    }

    chargerMe();
    return () => {
      mounted = false;
    };
  }, [token]);

  useEffect(() => {
    if (token) {
      localStorage.setItem('shopmarega_token', token);
    } else {
      localStorage.removeItem('shopmarega_token');
    }
  }, [token]);

  useEffect(() => {
    if (utilisateur) {
      localStorage.setItem('shopmarega_utilisateur', JSON.stringify(utilisateur));
    } else {
      localStorage.removeItem('shopmarega_utilisateur');
    }
  }, [utilisateur]);

  async function inscription({ nom, email, mot_de_passe }) {
    const { data } = await api.post('/auth/inscription', { nom, email, mot_de_passe });
    setToken(data.token);
    setUtilisateur(data.utilisateur);
    return data.utilisateur;
  }

  async function connexion({ email, mot_de_passe }) {
    const { data } = await api.post('/auth/connexion', { email, mot_de_passe });
    setToken(data.token);
    setUtilisateur(data.utilisateur);
    return data.utilisateur;
  }

  function deconnexion() {
    setToken('');
    setUtilisateur(null);
  }

  const value = useMemo(
    () => ({
      token,
      utilisateur,
      estConnecte: Boolean(token),
      estAdmin: utilisateur?.role === 'admin',
      inscription,
      connexion,
      deconnexion
    }),
    [token, utilisateur]
  );

  return <AuthContexte.Provider value={value}>{children}</AuthContexte.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContexte);
  if (!ctx) {
    throw new Error('useAuth doit être utilisé dans AuthProvider');
  }
  return ctx;
}
